import * as yup from 'yup';
import _ from 'lodash';
import { RotateCaptainConf } from './common/RotateCaptain.conf';
import { CommonUpdate } from './common/CommonUpdate';
import { CaptainUpdateConf } from './common/Captain.update.conf';

export const UpdateConf = {
	Crew: {
		Captain: {
			schema: yup.object({
				...CommonUpdate.schema,
				...CaptainUpdateConf.schema
			}),
			defaultValues: {
				...CommonUpdate.defaultValues,
				...CaptainUpdateConf.defaultValues
			},
			fields: _.concat(
				CommonUpdate.fields.slice(0, 3),
				CaptainUpdateConf.fields.slice(0, 2),
				CommonUpdate.fields.slice(5, 9),
				CaptainUpdateConf.fields.slice(2),
				CommonUpdate.fields.slice(9)
			),
		},
		"Rotate Captain": {
			schema: yup.object({
				...CommonUpdate.schema,
				...RotateCaptainConf.schema
			}),
			defaultValues: {
				...CommonUpdate.defaultValues,
				...RotateCaptainConf.defaultValues
			},
			fields: _.concat(CommonUpdate.fields.slice(0, 9), RotateCaptainConf.fields, CommonUpdate.fields.slice(9)),
		},
		Common: {
			schema: yup.object({
				...CommonUpdate.schema
			}),
			defaultValues: {
				...CommonUpdate.defaultValues
			},
			fields: CommonUpdate.fields,
		}
	},

};
